import { RCXAdapter } from 'rcx_adapter/src';

import { ServiceNowAdapter } from '../adapter';
import { ModuleBaseOption } from '../interfaces/module';

abstract class BaseModule<T extends ModuleBaseOption> {
    private _init = false;
    protected mServiceNowAdapter?: ServiceNowAdapter;
    protected mRCXAdapter?: RCXAdapter;
    init(options: T) {
        this.mServiceNowAdapter = options.serviceNowAdapter;
        this.mRCXAdapter = options.rcxAdapter;
        this._init = true;
        return this;
    }
    getIsInit() {
        return this._init;
    }
    public abstract start(): void;
}

export { BaseModule };
